import { useQuery } from "@tanstack/react-query";
import { getBatch } from "@/api/client";

/** A batch's name, or its creation date when it has none. */
export function batchLabel(batch: { name?: string | null; created_at?: string }): string {
  const name = batch.name?.trim();
  if (name) return name;
  if (!batch.created_at) return "Untitled batch";
  return `Untitled batch · ${new Intl.DateTimeFormat(undefined, { dateStyle: "medium" }).format(new Date(batch.created_at))}`;
}

/** The label of the batch with this id, fetched once and cached; "…" while it loads. */
export function useBatchLabel(id: string | undefined): string {
  const batch = useQuery({ queryKey: ["batch", id], queryFn: () => getBatch(id!), enabled: Boolean(id) });
  return batch.data ? batchLabel(batch.data) : "…";
}
